
import { Component, Prop, Vue } from 'vue-property-decorator'
import { PaymentMethod } from '../models/PaymentMethod'
import {currency} from '../utils/format'

@Component({})
export default class PaymentInfo extends Vue {
  @Prop({ required: true }) readonly method!: PaymentMethod & { formattedExpirationDate?: string }
  @Prop({ default: 'message.totalAmount' }) readonly totalAmountLabel!: string

  get hasRate() {
    return parseFloat(this.method.rate) !== 1
  }

  get hasFees() {
    return this.method.fees.length > 0
  }

  get formattedOrderAmount() {
    return this.formatAmount(
      this.method.orderAmount,
      this.method.orderCurrency,
    )
  }

  get formattedConvertedAmount() {
    return this.formatAmount(
      this.method.convertedAmount,
      this.method.currency,
    )
  }

  get formattedAmount(): string {
    return this.formatAmount(
      this.method.amount,
      this.method.currency,
    )
  }

  formatFee(value: string): string {
    const [amount, curr] = value.split(' ')
    return this.formatAmount(amount, curr)
  }

  formatAmount(value: string, curr: string) {
    return currency(Number(value) || 0, curr)
  }
}
